import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/EngagementStudent.scss";
import Breadcrumb from "../components/Breadcrumb";
import List from "../components/List";
import AuthStore from "../stores/AuthStore";
import {Loader} from '../components/Loader';

@inject('Navigator', 'ConfigStore', 'StudentStore', 'AuthStore', 'SchoolStore')
@observer
export default class EngagementStudent extends Component {

    static breadcrumbSegments = [
        {
            title: "Teacher's Desk",
            uri: "/"
        },
        {
            title: "Engagement Report",
            uri: ""
        }];

    constructor(props) {
        super(props);

        this.state = {
            searchStudent: '',
            studentId: '',
            studentLevel: '',
            students: [],
            oldLessons: null
        }
    }

    componentWillUnmount(){
        this.props.SchoolStore.isSearch = false;
    }

    componentWillMount() {
        

        const searchStudent = this.props.params.searchStudent;
        this.setState({searchStudent:searchStudent});
        const {
            studentId
        } = this.props.params;

        let studentSearched = searchStudent;
        let studentLevel = '';
        let unit_id = null;
        if( searchStudent == undefined) {
            if (studentId) {
                studentSearched = this.props.SchoolStore.studentsEngagement.find(s => s.id === studentId);
                unit_id =  studentSearched.unitIdSf;

                studentLevel = studentSearched.level;
                studentLevel = studentLevel === "basic-1" ? 2 : studentLevel === "basic-2" ? 3 : studentLevel === "basic-3" ? 4
                    : studentLevel === "intermediate-1" ? 5 : studentLevel === "intermediate-2" ? 6 : studentLevel === "intermediate-3" ? 7
                        : studentLevel === "advanced-1" ? 8 : studentLevel === "advanced-2" ? 9 : "";
                studentSearched = studentSearched.firstName + ' ' + studentSearched.lastName;

            }
        }

        if( unit_id == null ) {
            unit_id = AuthStore.units[0].id;
        }

        if(!this.props.SchoolStore.isDetail) {
            this.props.SchoolStore.isLoading = true;
            this.props.SchoolStore.getLessonsByStudent(studentId,studentLevel).then(
                response => {
                    if( response == false) {
                        this.props.SchoolStore.noResult = true;
                    } else {
                        this.props.SchoolStore.noResult = false;
                    }
                    this.props.SchoolStore.isLoading = false;
                }
            );
            this.props.SchoolStore.noResult = false;
        }
    }

    handleBreadcrumbClick(uri) {
        this.props.ConfigStore.animationType = "right";
        this.props.Navigator.push(uri);
    }

    handleClickStudent(studentId) {
        // this.props.SchoolStore.isDetail = true;
        // this.props.Navigator.push(`/detail-student/${studentId}`);
    }

    render() {

        if( this.props.SchoolStore.isLoading == false ) {
            const {
                studentId
            } = this.props.params;

            let resultSearch = this.props.SchoolStore.lessons;

            let book = "";

            var list = [];
            if ( this.props.SchoolStore.noResult == false ) {

                list = resultSearch.map(
                    lesson => {
                        if(lesson.first){
                            let status = "";
                            if( lesson.status === 1 ){
                                status = <td><div className="check-green"></div></td>;
                            } else if ( lesson.status === 2 ) {
                                status = <td><div className="exclamation"></div></td>;
                            } else if ( lesson.status === 3 ) {
                                status = <td><div className="fail"></div></td>;
                            } else {
                                status = <td><div className="status-none"></div></td>;
                            }

                            let score = "";
                            if( lesson.status < 3 ){ //atrasado e não feito
                                score = lesson.score + '%';
                            }

                            book = lesson.book;
                            return (
                                <tr>
                                    {status}
                                    <td><div className="name">{lesson.book} - {lesson.lessonName}</div></td>
                                    <td><div className="score">{score}</div></td>
                                    <td><div className="date">{lesson.classDate}</div></td>
                                    <td><div className="preparation">{lesson.preparationDone}</div></td>
                                </tr>
                            )
                        }
                    }
                );
            }

            this.props.SchoolStore.isDetail = false;

            return (
                <div className="EngagementStudent Page">
                    <div className="container">
                        <div className="header-section">
                            <h1>Lessons:</h1>
                            <Breadcrumb segments={EngagementStudent.breadcrumbSegments}
                                        onClick={this.handleBreadcrumbClick.bind(this)}/>
                            <p className="btn-back" onClick={() => this.props.Navigator.goBack()}>&lt; back</p>
                        </div>
                        <div className="contents">
                            <List counter={list.length}
                                  messageEmpty={'No lessons found.'}
                                  loader={this.props.StudentStore.isLoading}>
                                <table>
                                    <tr className="tr-th">
                                        <th className="tr-icon"></th>
                                        <th className="tr-lesson">Lesson</th>
                                        <th className="tr-score">Score</th>
                                        <th className="tr-date">Class Date</th>
                                        <th className="tr-preparation">Preparation Done</th>
                                    </tr>
                                    {list}
                                </table>
                            </List>
                        </div>

                    </div>
                </div>
            );
        } else {
            return (<Loader inverted />);
        }


    }

}


// WEBPACK FOOTER //
// ./src/containers/EngagementStudent.js